import { mapClosingPackageApiError } from './errorMapping';
import type { CompositionActionHandlerResult } from './compositionActionHandlers';

const INITIALIZE_SUCCESS_MESSAGE = 'Рекомендуемый состав применён';

export type InitializeCompositionDeps = {
  initializeComposition: (args: {
    applicationId: number;
    body?: { comment?: string | null };
  }) => Promise<unknown>;
  requestInitializeConfirmation: () => Promise<boolean>;
  notifySuccess: (message: string) => void;
  notifyError: (error: unknown, fallback: string) => void;
  onInitializeStart?: () => void;
  onInitializeEnd?: () => void;
};

/** Header command handler — confirm → RTK initialize mutation (via injected deps). */
export async function executeInitializeComposition(
  deps: InitializeCompositionDeps,
  applicationId: number
): Promise<CompositionActionHandlerResult> {
  const confirmed = await deps.requestInitializeConfirmation();
  if (!confirmed) {
    return 'cancelled';
  }

  deps.onInitializeStart?.();

  try {
    await deps.initializeComposition({ applicationId });
    deps.notifySuccess(INITIALIZE_SUCCESS_MESSAGE);
    return 'success';
  } catch (error) {
    deps.notifyError(
      error,
      mapClosingPackageApiError(error, 'Не удалось применить рекомендуемый состав')
    );
    return 'error';
  } finally {
    deps.onInitializeEnd?.();
  }
}
